import React, { useState } from "react";
import { Stack } from "react-bootstrap";
import styled from "styled-components";
import { MissInfoReport } from "../../components/MissInfo";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import SimpleDateFilters from "./_SimpleDateFilters";
import AdminReportSmsSummaryList from "./_AdminReportSmsSummaryList";
import { useAuth } from "../../Context/AuthContext";
import { httpClient } from "../../utils/HttpClient";
const Divider = styled.div`
  background: #dfdfdf;
  width: 100%;
  height: 1px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const ReportSmsSummaryAdmin = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [reportData, setReportData] = useState(null);
  const [periodStr, setPeriodStr] = useState("");
  const [loading, setLoading] = useState(false);

  const getDataReport = (filters) => {
    setReportData(null);
    setLoading(true);
    const URI = ApiEndpoint + "administration/report/customerchannelsummary";
    console.log(filters.dateFrom);
    console.log(filters.dateTo);
    httpClient(
      "POST",
      URI,
      {
        from: filters.dateFrom,
        to: filters.dateTo,
        carrier: filters.idcarrier,
        shortcode: filters.idshortcode,
        onlyread: "false",
      },
      userData.token
    )
      .then(function (response) {
        setReportData(response.data);

        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  return (
    <>
      <div className="">
        <Stack direction="horizontal" gap={2}>
          <div>
            <h2>Resumen de Mensajes enviados por cliente</h2>
            <h3>Todos los Clientes</h3>
          </div>
        </Stack>

        <div className="ReportDate">
          <SimpleDateFilters
            onRefresh={getDataReport}
            setPeriodStr={setPeriodStr}
            loading={loading}
          />
        </div>

        <Divider />
        {reportData ? (
          <>
            <AdminReportSmsSummaryList
              periodStr={periodStr}
              listMessages={reportData}
            ></AdminReportSmsSummaryList>
          </>
        ) : (
          <MissInfoReport />
        )}
      </div>
    </>
  );
};

export default ReportSmsSummaryAdmin;
